export const stopPropagation = (e) => {
    e.nativeEvent.stopImmediatePropagation();
    e.preventDefault();
    e.stopPropagation();
};



// WEBPACK FOOTER //
// ./src/cyverse-ui/utils/events.js